import React from 'react';
import { Typography } from 'fronton-react';
import { CaptionBlock, captionText } from './styles';
import type { AdBadgeProps, AdBadgeVariant } from './types';
import { InfoIcon } from '@fronton/icons-react';
import { HintWrapper } from 'common/components/hint-wrapper';
const setBadgeVariant = (variant: AdBadgeVariant) => {
  switch (variant) {
    case 'text':
      return (
        <Typography variant="caption" className={captionText}>
          реклама
        </Typography>
      );
    case 'icon':
    default:
      return <InfoIcon type="outline" size="m" color="text-minor" />;
  }
};
export const AdBadge = ({ variant = 'text', className, children }: AdBadgeProps) => {
  return (
    <HintWrapper
      anchor={
        <CaptionBlock variant={variant} className={className}>
          {setBadgeVariant(variant)}
        </CaptionBlock>
      }
      placement="bottom">
      {children}
    </HintWrapper>
  );
};
